import React, { useContext, useEffect } from 'react'

import { Col, Row, Spin } from 'antd'
import { ApplicationContext } from 'Context'
import handleToken from 'Services/handleToken'

const SessionClosed = () => {
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  useEffect(() => {
    handleToken.cleanToken()

    setApplicationContext({})

    if (!applicationContext.usuarioAtual) {
      setTimeout(() => location.assign('/auth'), 3000)
    }
  }, [])

  useEffect(() => {
    if (!applicationContext.usuarioAtual) {
      setTimeout(() => location.assign('/auth'), 3000)
    }
  }, [applicationContext])

  return (
    <Col style={{ height: '100vh', width: '100%' }}>
      <Row
        align="middle"
        justify="center"
        style={{ height: '100vh', width: '100%' }}
      >
        <Spin size="large" />
        <div
          style={{
            fontSize: '20px',
            fontWeight: 600,
            marginTop: '-8px',
            marginLeft: '15px',
          }}
        >
          Sua sessão expirou, efetue login novamente.
        </div>
      </Row>
    </Col>
  )
}

export default SessionClosed
